import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, CheckCircle2 } from "lucide-react";

export default function Unsubscribe() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => { api.unsubscribeInfo(token).then(setInfo).catch(() => setErr("This unsubscribe link is invalid or expired.")); }, [token]);
  const doIt = async () => { setBusy(true); try { await api.unsubscribeDo(token); setDone(true); } catch { setErr("Could not process. Please try again."); } setBusy(false); };
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A0A0A] px-4 text-white" data-testid="unsubscribe-page">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-white/[0.02] p-8 text-center">
        <div className="text-xl font-bold">Caption Motion</div>
        {err ? <p className="mt-4 text-[#ef4444]" data-testid="unsub-error">{err}</p>
          : done ? (
            <div className="mt-6" data-testid="unsub-done">
              <CheckCircle2 className="mx-auto text-[#22c55e]" size={40} />
              <p className="mt-3 text-white/90">You're unsubscribed from Caption Motion marketing emails.</p>
              <p className="mt-1 text-sm text-[#A1A1AA]">You will no longer receive marketing emails from us.</p>
            </div>
          ) : !info ? <Loader2 className="mx-auto mt-6 animate-spin text-[#00F0FF]" />
            : (
              <div className="mt-6">
                <p className="text-white/90">Unsubscribe <span className="font-mono">{info.email_masked}</span> from Caption Motion marketing emails?</p>
                <button data-testid="unsub-confirm-btn" disabled={busy} onClick={doIt} className="mt-5 w-full rounded-lg bg-[#00F0FF] px-4 py-2.5 font-bold text-black disabled:opacity-50">{busy ? "Processing…" : "Unsubscribe"}</button>
                <p className="mt-3 text-xs text-[#A1A1AA]">Transactional emails (receipts, security, account) are unaffected.</p>
              </div>
            )}
      </div>
    </div>
  );
}
